import * as restApi from "./restApi";

const collectionUrl = "api/permission";

// export const existsRecord = restApi.existsRecord.bind(null, {}, collectionUrl);
// export const fetchRecord = restApi.fetchRecord.bind(null, {}, collectionUrl);
export const fetchRecords = restApi.fetchRecords.bind(null, {}, collectionUrl);
export const updateRecord = restApi.updateRecord.bind(null, {}, collectionUrl);
// export const insertRecord = restApi.insertRecord.bind(null, {}, collectionUrl);
